import { useRouter } from 'vue-router'
import { useAppStore } from '@stores/app.store'
import { useGtm } from '@composables/useGtm'
import { logInfo, scopedLogger } from '@lib/utils/logUtils'

const log = scopedLogger('@composables/useGoToCheckout.ts')

/**
 * Advances from the cart to checkout (through crossSelling if not seen yet), unless the user
 * must pass an identity check first (OTP validation or ConfirmingIdentity), see
 * store.identityCheckBeforeCheckout.
 */
export const useGoToCheckout = () => {
  const store = useAppStore()
  const router = useRouter()
  const { trackBeginCheckout } = useGtm()

  const goToCheckout = async () => {
    const check = store.identityCheckBeforeCheckout
    if (check === 'otp') {
      logInfo(log, 'Cannot advance to checkout, user must validate OTP')
      await router.push({ name: 'otp-validation' })
      return
    }
    if (check === 'confirm') {
      logInfo(log, 'Cannot advance to checkout, user must confirm identity')
      await router.push({ name: 'confirming-identity' })
      return
    }
    trackBeginCheckout()
    if (store.crossSellingCheckoutIsViewed) await router.push({ name: 'checkout' })
    else await router.push({ name: 'crossSelling', query: { checkout: 'true' } })
  }

  return { goToCheckout }
}
